export default __webpack_public_path__ + "static/media/img10.f6454a96.jpg";